export const hospitalURL = (route, param) => {
  const baseURL = process.env.REACT_APP_BASE_URL
  const url = {
    hospitals: `${baseURL}/JOK_OPDEnroll`,
    embassy: `${baseURL}/JOK_GPTEmbassyEnroll`,
    getToken: `${baseURL}/JOK_GetToken`,
  }

  return url[route] || baseURL
}

export default hospitalURL
